'use strict';

angular.module('app.brand', [])
    .config([
      '$stateProvider',
      function ($stateProvider) {
        return $stateProvider.state('app.brand', {

          templateUrl: 'components/brand/brandView.html',

          controller: [
            '$scope', '$window',
            function ($scope, $window) {
              $scope.logoEpsDownload = function (url) {
                $window.open(url);
              }
            }
          ],

          url: '/corporate-brand',
          title: 'Logo Usage Guidelines',
          noSidebar: true,
          noTopControls: true,
          params: {obj: null}
        });
      }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/brand/brand.js